import styled from 'styled-components';
import { AllowedActionMenuElements, ButtonOption } from 'ui/actionMenu/types';
import { colors } from 'ui/theme';
import { useTranslation } from '../useTranslation';
import { REMOVE_CUSTOM_INSIGHT_ACTION_ID } from '../../constants';
import { InsightType } from '../../types';
import { useDeleteCustomInsight } from './useDeleteCustomInsight';

const StyledSpan = styled.span`
  color: ${colors.red100};
`;

export const useCustomInsightOptions = (
  insight: string,
  type: InsightType | null,
): ButtonOption[] => {
  const { t } = useTranslation();
  const deleteCustomInsight = useDeleteCustomInsight(insight, type);

  return [
    {
      as: AllowedActionMenuElements.Button,
      content: <StyledSpan>{t('insights.customInsightRemoval')}</StyledSpan>,
      id: REMOVE_CUSTOM_INSIGHT_ACTION_ID,
      onClick: deleteCustomInsight,
    },
  ];
};
